import { asNumber, getHTMLStringAsText } from "@frontend/unhideschool/app/helpers/utility-functions";
import { GroupItem, GroupItemBuilder } from "../models/group-item.model";
import { PlaylistItemRequestDataModel } from "../models/player-item-request-data.model";
import { PlayerItemBuilder, PlaylistItem } from "../models/player-item.model";
import { CommentRequestDataItem } from "../ngxs/player-state.model";
import { environment } from "@frontend/unhideschool/env";

export const hydrateCommentTree = (
  context: CommentRequestDataItem[],
  commentsList: CommentRequestDataItem[][]
) => {
  for (const replies of commentsList) {
    const rootcommentid = asNumber(replies[0]?.rootcommentid);

    const comment = context.find(comment => {
      const postpartcommentid = asNumber(comment.postpartcommentid);
      return postpartcommentid === rootcommentid;
    });

    if (comment != undefined) {
      comment.replies.items = replies;
      commentsList = commentsList.filter(rps =>
        !rps.some(rp => rp.rootcommentid === rootcommentid));
      continue;
    }

    context
      .filter(upperComment => upperComment.replies.items?.length)
      .forEach(upperComment => hydrateCommentTree(
        upperComment.replies.items, commentsList)
      );
  }
};

export function groupBy(arr: PlaylistItemRequestDataModel[], key) {
  return arr.reduce((acc, current) => {
    const iconSettings = {
      views: {
        path: environment.cdnUrl + '/player/image-icons/player-view-icon.png',
        labelDesktop: current.views && (current.views < 1000 || current.likes == 0) ? 'Visualizações' : 'k',
        labelMobile: ''
      },
      likes: {
        path: environment.cdnUrl + '/player/svg-icons/player-like-icon.svg',
        labelDesktop: current.likes ? ((current.likes < 1000) || current.likes == 0) ? 'Curtidas' : 'k' : 'Curtidas',
        labelMobile: ''
      },
      comments: {
        path: environment.cdnUrl + '/player/svg-icons/player-comments-count-icon.svg',
        labelDesktop: current.comments ? (current.comments.totalCount < 1000 ? 'Comentários' : (current.comments.totalCount == 0) ? '' : 'k') : 'Comentários',
        labelMobile: ''
      },
    }
    const toolbarItems = [
      {
        icon: iconSettings.likes.path,
        value: current.likes ? current.likes : 0,
        labelDesktop: iconSettings.likes.labelDesktop,
        labelMobile: iconSettings.likes.labelMobile
      },
      {
        icon: iconSettings.comments.path,
        value: current.comments ? current.comments.totalCount : 0,
        labelDesktop: iconSettings.comments.labelDesktop,
        labelMobile: iconSettings.comments.labelMobile
      },
    ];
    let video = {} as any;
    try {
      video = PlayerItemBuilder(current, toolbarItems);

    } catch (e) {
      console.log(e);
    }
    const currentTotalSeconds = getTotalSeconds(current.content);
    const groupname = current[key];
    const groupIndex = acc.findIndex((group: GroupItem) => {
      return group.name.toLowerCase() == groupname.toLowerCase();
    });
    const groupFound = groupIndex > -1;
    if (groupFound) {
      const group = acc[groupIndex];

      const calculatedProgress = (asNumber(group.progress) + asNumber(video.progress));
      const thumbnailcropstrategy = '?tr=w-170,c-at_max';
      video.thumbnail = video.thumbnail + thumbnailcropstrategy;
      group.videos = [...group.videos, video];
      group.totaltime += currentTotalSeconds;
      group.progress = calculatedProgress;

      acc[groupIndex] = group;

      return acc;
    }

    const newGroup = GroupItemBuilder({
      name: groupname,
      videos: [video],
      progress: current.progress ? current.progress : 0,
      totaltime: currentTotalSeconds,
      completed: false
    })

    return [...acc, newGroup];
  }, []);

}

function getTotalSeconds(content) {
  if (content) {
    const parsedContent = JSON.parse(content);
    return Number(parsedContent[1]) || 0;
  } else {
    return 0;
  }
}

/**
 *
 * @param orderedpostpartid
 * @param groupList | a list of groups
 * @returns
 */
export function getVideoInGroup(groupList, key: string, value: any): PlaylistItem {
  let video;

  if (!key) {
    throw new Error(`key param not defined`);
  }

  for (const group of groupList) {
    switch (key) {
      case 'otp': {
        video = group.videos.find(video => {
          if (video[key] && video[key].otp) {
            return video[key].otp == value.otp;
          }

          return false;
        });
      } break;
      case 'videoid': {
        video = group.videos.find(video => video.content[0] == asNumber(value));
      } break;
      default: {
        video = group.videos.find(video => video[key] == value);
      }
    }

    if (video != undefined) {
      break;
    }
  }

  return video;
}

// setNextInAutoPlay(){

// }


export function formatTotalTime(group, format?) {
  if (format == 'minutes') {
    return (group.totaltime * 1000) < 3600 ? new Date(group.totaltime * 1000).toISOString().substr(11, 5) : new Date(group.totaltime * 1000).toISOString().substr(14, 5);

  }
  const time = new Date(group.totaltime * 1000).toISOString().substr(11, 5).replace(':', 'h')
  return asNumber(time.split('h')[0]) >= 10 ? time : time.substring(1, time.length);
}


export function checkCommentImageValidToSend(html) {
  const text: string = getHTMLStringAsText(html);
  return !(text.trim() === '');
}
